import { render, staticRenderFns } from "./InputprofilePage.vue?vue&type=template&id=47b6f264"
import script from "./InputprofilePage.vue?vue&type=script&lang=js"
export * from "./InputprofilePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports